import { Component, Input, OnChanges } from '@angular/core';
import { ConfirmData } from '../details/booking/sendData';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: 'confirm.component.html',
  styleUrls: ['confirm.component.css']
})

export class ConfirmComponent implements OnChanges {

  @Input() confirmData;

confirmDataa;

  type: string;
  customers: any[];
  totalPriceString: string;
  travelPeriod: string;
  fromAirport: string;
  toAirport: string;
  participants: any[];

  constructor(private translate: TranslateService) {
    this.customers = [
      "",
      "",
      "",
      "",
      "",
      ""
    ];
  }

  ngOnChanges() {
    if (this.confirmData !== undefined) {
      this.type = this.confirmData.type;
      this.customers = this.confirmData.customers;
      this.totalPriceString = this.confirmData.totalPriceString;
      this.travelPeriod = this.confirmData.travelPeriod;
      this.toAirport = this.confirmData.flight.toAirport;
      this.fromAirport = this.confirmData.flight.fromAirport;
      this.participants = this.confirmData.participants;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/confirm.component.ts